import Storage from 'vue-ls'

const storageOptions = {
  namespace: '', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
}

export { Storage, storageOptions }
